import BasicModel from "./basic_model";

export default class Cone extends BasicModel {
  render = () => {
    this.setupContext();

    const x = this.x();
    const y = this.y();
    const s = this.context.scale;

    this.context.beginPath();
    this.context.arc(x, y, 10*s, -0.5 * Math.PI, 1.5 * Math.PI, true);
    this.context.moveTo(x, y-3*s)
    this.context.arc(x, y, 4*s, -0.5 * Math.PI, 1.5 * Math.PI, true);
    this.context.fill();
    this.context.stroke();

    this.resetContext();
  }

  boundingBox = function() {
    const w = 10 * this.context.scale;

    return {
      x: this.x() - w,
      y: this.y() - w,
      w: w * 2,
      h: w * 2
    }
  }

}
